module.exports = __webpack_public_path__ + "img/parley_1.61172f51.png";